// extracted by mini-css-extract-plugin
export default {"btn":"DangerButton_btn__6JcnA"};